import { useState, useEffect } from "react"
import { useTenant } from "../../../hooks/useTenant"
import { EnrollmentService } from "../../../services/enrollment_service"
import MemberService from "../../../services/member_service"

/**
 * useClassMembers
 * Busca os membros matriculados em uma turma usando o EnrollmentService do NeoApp.
 * Enriquece os dados com informações completas do MemberService.
 */
export const useClassMembers = ({ classId, withLoading }) => {
    const { idTenant } = useTenant()
    const [members, setMembers] = useState([])

    useEffect(() => {
        setMembers([]) // Clear immediately to prevent old data flash
        
        if (!classId) {
            return
        }

        const fetchMembers = async () => {
            try {
                // 1. Buscar membros matriculados na turma e lista completa em paralelo
                const [enrolled, membersList] = await Promise.all([
                    EnrollmentService.getEnrolledMembersByClass(idTenant, classId),
                    MemberService.getMembers(idTenant)
                ])

                // 2. Enriquecer os matriculados com dados reais do membro
                const mapped = (enrolled || []).map(e => {
                    const memberInfo = membersList.find(m => m.id === e.id) || {}

                    return {
                        id: e.id,
                        idMember: e.id,
                        name: memberInfo.fullName || e.fullName || "Aluno",
                        photo: memberInfo.photoUrl || null,
                        memberNumber: memberInfo.memberNumber || "",
                        status: memberInfo.status || "active",
                        email: memberInfo.email || "",
                        phone: memberInfo.phone || memberInfo.cellPhone || "",
                        cellPhone: memberInfo.cellPhone || "",
                        responsavelPhone: memberInfo.responsavelPhone || "",
                    }
                })

                setMembers(mapped)
            } catch (error) {
                console.error("Erro ao buscar alunos da turma:", error)
                setMembers([])
            }
        }

        if (withLoading) {
            withLoading('classMembers', fetchMembers)
        } else {
            fetchMembers()
        }
    }, [classId, idTenant, withLoading])

    return { members }
}
